import usdl from 'usdl-regex';

export default function isValidLicense(state, number) {
  if (!state || !number) {
    return false;
  }

  return usdl.isValid(state, number);
}
